import React from 'react'
import {Button} from "@material-ui/core";
import {useGoogleLogin} from '@react-oauth/google';
import AppleSignin from 'react-apple-signin-auth';

export const AuthButtonsBlock = ({authStore}) => (
    <div>
        <div className="title-block">Войти с помощью</div>
        <div
            className={authStore.loading ? 'disabled-buttons buttons-block' : 'buttons-block'}
            onClick={authStore.onAuthClick}>
            <Button variant="contained" onClick={authStore.vkStartAuth}>
                Вконтакте
            </Button>
            <AppleSignin
                authOptions={{
                    clientId: 'tonesky.ru',
                    scope: 'email name',
                    redirectURI: 'https://tonesky.ru/booking/cabinet',
                    state: '',
                    nonce: 'nonce',
                    usePopup: true,
                }}
                onSuccess={authStore.appleAuth}
                onError={authStore.responseError.bind(this, 'apple')}
                noDefaultStyle={true}
                className="MuiButtonBase-root MuiButton-root MuiButton-contained apple-button"
                uiType="dark"
                buttonExtraChildren={<span className="MuiButton-label"
                                           onClick={authStore.onAuthClick}>Apple ID</span>}
            />
            <Button variant="contained"
                    onClick={useGoogleLogin({
                        onSuccess: async (tokenResponse) => {
                            const accessToken = tokenResponse.access_token;

                            const res = await fetch(
                                "https://www.googleapis.com/oauth2/v3/userinfo",
                                {
                                    headers: {
                                        Authorization: `Bearer ${accessToken}`,
                                    },
                                }
                            );

                            const profile = await res.json();
                            return authStore.googleAuth({
                                id: profile.sub,
                                name: profile.name,
                                email: profile.email,
                                photo: profile.picture,
                                access_token: accessToken,
                            })
                        },
                        onFailure: authStore.responseError.bind(this, 'google'),
                        flow: 'implicit',
                        scope: 'openid email profile',
                    })}>Google</Button>
        </div>
        <div className='register-error'>{authStore.errorMessage}</div>
        <div className="privacy-policy">
            <a href="https://app.tonesky.ru/privacypolicy" target="_blank"
               rel="noopener noreferrer">
                Политика конфиденциальности
            </a>
        </div>
    </div>
);

export default AuthButtonsBlock
